import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a17cddb2")

_pushScopeId("data-v-a17cddb2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("使用说明")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("常见问题")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("更新日志")
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "screen-option" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("手机预览")
const _hoisted_7 = {
  class: "qrcode",
  ref: "qrcodeRef"
}
const _hoisted_8 = { class: "help_flex" }
const _hoisted_9 = {
  class: "tree_box",
  id: "tree_box"
}
const _hoisted_10 = { class: "tree-font-size" }
const _hoisted_11 = {
  key: 1,
  class: "update-log-content"
}
const _hoisted_12 = {
  key: 0,
  class: "journal-list"
}
const _hoisted_13 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_14 = { class: "help_title" }
const _hoisted_15 = {
  key: 0,
  class: "el-icon-arrow-right"
}
const _hoisted_16 = { class: "help_content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_HelpSearchBar = _resolveComponent("HelpSearchBar")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_v_md_preview_html = _resolveComponent("v-md-preview-html")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_menu, {
      "default-active": _ctx.activeIndex,
      class: "el-menu-demo",
      mode: "horizontal",
      onSelect: _ctx.handleSelect,
      "text-color": "#f4f4f5",
      "active-text-color": "#409eff",
      "background-color": "#304156"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_menu_item, { index: "1" }, {
          default: _withId(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "2" }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "3" }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active", "onSelect"]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_HelpSearchBar, {
          data: _ctx.searchData,
          onHelpScreenQuery: _ctx.helpScreenQuery,
          style: {"margin-bottom":"0"}
        }, null, 8, ["data", "onHelpScreenQuery"]),
        _createVNode(_component_el_popover, { placement: "bottom" }, {
          reference: _withId(() => [
            _createVNode(_component_el_button, { type: "text" }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          default: _withId(() => [
            _createVNode("div", _hoisted_7, null, 512)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          (_ctx.activeIndex == '1' || _ctx.activeIndex == '2')
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: _ctx.filterText,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterText = $event)),
                placeholder: "输入关键字进行过滤"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.activeIndex == '3')
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                placeholder: "请输入关键字",
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.keyword = $event)),
                class: "input-with-select",
                onKeyup: _withKeys(_ctx.getUpdateLog, ["enter"])
              }, {
                append: _withId(() => [
                  _createVNode(_component_el_button, {
                    icon: "el-icon-search",
                    onClick: _ctx.getUpdateLog
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["modelValue", "onKeyup"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_scrollbar, { class: "scrollbar-height" }, {
            default: _withId(() => [
              (_ctx.activeIndex == '1' || _ctx.activeIndex == '2')
                ? (_openBlock(), _createBlock(_component_el_tree, {
                    key: 0,
                    data: _ctx.menuDatas,
                    "node-key": "id",
                    ref: "treeRef",
                    class: "customize-tree",
                    "filter-node-method": _ctx.filterNode,
                    "expand-on-click-node": false,
                    "highlight-current": "",
                    onNodeClick: _ctx.clickChildren
                  }, {
                    default: _withId(({ data }) => [
                      _createVNode("span", _hoisted_10, _toDisplayString(data.cateName), 1)
                    ]),
                    _: 1
                  }, 8, ["data", "filter-node-method", "onNodeClick"]))
                : _createCommentVNode("", true),
              (_ctx.activeIndex == '3')
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    (_ctx.updateLogList.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.updateLogList, (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              class: ["journal-li", item.id == _ctx.curSelectId ? 'active' : ''],
                              key: index,
                              onClick: ($event: any) => (_ctx.clickItem(item))
                            }, _toDisplayString(item.date), 11, ["onClick"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.updateLogList.length)
                      ? (_openBlock(), _createBlock("p", _hoisted_13, "暂无数据"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.updateLogList.length && _ctx.activeIndex == '3')
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 2,
                class: "el-pagination",
                background: "",
                onCurrentChange: _ctx.getUpdateLog,
                currentPage: _ctx.pages,
                "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pages = $event)),
                layout: "total, prev, next, jumper",
                total: _ctx.total
              }, null, 8, ["onCurrentChange", "currentPage", "total"]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createVNode(_component_el_scrollbar, {
          class: "content-scrollbar",
          id: "content-scrollbar"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_14, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.titleArr, (item, index) => {
                return (_openBlock(), _createBlock("span", { key: index }, [
                  _createTextVNode(_toDisplayString(item) + " ", 1),
                  (index + 1 != _ctx.titleArr.length)
                    ? (_openBlock(), _createBlock("i", _hoisted_15))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_v_md_preview_html, {
                html: _ctx.htmlText,
                "preview-class": "vuepress-markdown-body"
              }, null, 8, ["html"])
            ])
          ]),
          _: 1
        }, 512), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ])
  ], 64))
})